import { Component } from '@angular/core';

@Component({
  selector: 'app-emp-grievance-link',
  templateUrl: './emp-grievance-link.component.html',
  styleUrls: ['./emp-grievance-link.component.scss']
})
export class EmpGrievanceLinkComponent {

}
